import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { RegisterForAccountStateChange } from 'owa-account-source-list';
import { type AccountSource } from 'owa-account-source-list-store';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { areAnyAccountsEnterpriseOrPremiumConsumer } from './utils/areAnyAccountsEnterpriseOrPremiumConsumer';
import { isLocalDataBackedMailboxInfo } from 'owa-account-source-list/lib/utils/isLocalDataBackedAccount';

let checked = false;
let enabled = false;

/**
 * This capability is used to determine if save as OFT capabilities should be supported.
 *
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 */
export const saveEmailAsOFTToFileCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        if (checked) {
            return enabled;
        }

        enabled = areAnyAccountsEnterpriseOrPremiumConsumer();
        checked = true;

        RegisterForAccountStateChange(onAccountsChanged, onAccountsChanged);

        return enabled;
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        if (!mailboxInfo) {
            return false;
        }

        // PST files do not support saving as OFT
        return (
            isGlobalFeatureEnabled('doc-saveAs-OFT') && !isLocalDataBackedMailboxInfo(mailboxInfo)
        );
    },
};

// Callback for when an account is added or removed
const onAccountsChanged = async (_accountSource: AccountSource) => {
    enabled = areAnyAccountsEnterpriseOrPremiumConsumer();
};
